import * as React from "react";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

export default function ChatStart({ token, onSessionStarted }) {
    const [userRole, setUserRole] = React.useState("all");
    const [engine, setEngine] = React.useState("agent");
    const [starting, setStarting] = React.useState(false);

    const getUserID = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/token/user_id`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: token }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data.user_id;
        } catch (error) {
            console.error("Failed to get user_id:", error);
        }
    }

    const startSession = async () => {
        setStarting(true);
        const userId = await getUserID();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/session/start`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Token": token
                },
                body: JSON.stringify({ user_id: userId, user_role: userRole, engine: engine }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            onSessionStarted(data.id_session);
        } catch (error) {
            console.error("Failed to start session:", error);
        } finally {
            setStarting(false);
        }
    };

    return (
        <Stack spacing={2} sx={{ maxWidth: 320 }}>
            <TextField
                select
                label="User Role"
                value={userRole}
                onChange={(e) => setUserRole(e.target.value)}
                size="small"
            >
                <MenuItem value="all">Admin</MenuItem>
                <MenuItem value="cs">Customer Service</MenuItem>
                <MenuItem value="eu">End User</MenuItem>
                <MenuItem value="in">Installer</MenuItem>
            </TextField>
            <TextField
                select
                label="Engine"
                value={engine}
                onChange={(e) => setEngine(e.target.value)}
                size="small"
            >
                <MenuItem value="agent">Agent</MenuItem>
                <MenuItem value="assistant">Assistant (Legacy)</MenuItem>
            </TextField>
            <Button variant="contained" onClick={startSession} disabled={starting}>
                Start Chat Session
            </Button>
        </Stack>
    );
}
